const KWAI_PIXEL_SCRIPT_URL = "https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js";

const installKwaiPixelBase = () => {
  if (window.kwaiq && window.kwaiq.load) {
    return;
  }

  window.KwaiAnalyticsObject = "kwaiq";
  const kwaiq = (window.kwaiq = window.kwaiq || []);
  kwaiq.methods = [
    "page",
    "track",
    "identify",
    "instances",
    "debug",
    "on",
    "off",
    "once",
    "ready",
    "alias",
    "group",
    "enableCookie",
    "disableCookie",
  ];

  const deferMethod = (target, method) => {
    target[method] = function () {
      target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };

  kwaiq.methods.forEach((method) => deferMethod(kwaiq, method));
  kwaiq.instance = function (pixelId) {
    const instance = (kwaiq._i && kwaiq._i[pixelId]) || [];
    kwaiq.methods.forEach((method) => deferMethod(instance, method));
    return instance;
  };
  kwaiq.load = function (pixelId, options) {
    kwaiq._i = kwaiq._i || {};
    kwaiq._i[pixelId] = [];
    kwaiq._i[pixelId]._u = KWAI_PIXEL_SCRIPT_URL;
    kwaiq._t = kwaiq._t || {};
    kwaiq._t[pixelId] = +new Date();
    kwaiq._o = kwaiq._o || {};
    kwaiq._o[pixelId] = options || {};

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `${KWAI_PIXEL_SCRIPT_URL}?sdkid=${pixelId}&lib=kwaiq`;
    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  };
};

const buildPurchaseParams = (data) => {
  const params = {
    content_id: data.transactionId || data.transaction_id || "deposit",
    content_type: "product",
    quantity: 1,
  };
  const value = Number(data.revenue || data.value || 0);
  if (Number.isFinite(value) && value > 0) {
    params.value = value;
    params.price = value;
  }

  const currency = String(data.currency || "").trim().toUpperCase();
  if (/^[A-Z]{3}$/.test(currency)) {
    params.currency = currency;
  }

  const userId = data.rid || data.user_id;
  if (userId) {
    params.mapping_id = String(userId);
  }

  return params;
};

export default class KwaiPixelAnalytics {
  constructor(pixelId) {
    this.pixelId = String(pixelId || "").trim();
    if (!this.pixelId) {
      return;
    }

    installKwaiPixelBase();
    window.kwaiq.load(this.pixelId);
    window.kwaiq.page();
    KwaiPixelAnalytics.instance = this;
  }

  SendEvent(event, data = {}) {
    if (!this.pixelId || !window.kwaiq) {
      return;
    }

    if (event === "register" || event === "register2") {
      console.log("[KwaiPixelAnalytics] track completeRegistration", {
        pixelId: this.pixelId,
        event,
      });
      this.track("completeRegistration");
      return;
    }

    if (event === "first_purchase" || event === "firstPurchase") {
      const params = buildPurchaseParams(data);
      console.log("[KwaiPixelAnalytics] track firstDeposit", {
        pixelId: this.pixelId,
        event,
        params,
      });
      this.track("firstDeposit", params);
      return;
    }

    if (event === "recharge" || event === "purchase") {
      const params = buildPurchaseParams(data);
      console.log("[KwaiPixelAnalytics] track purchase", {
        pixelId: this.pixelId,
        event,
        params,
        is_first_purchase: Boolean(data.isFirstPurchase || data.is_first_purchase),
      });
      this.track("purchase", params);
      if (data.isFirstPurchase || data.is_first_purchase) {
        console.log("[KwaiPixelAnalytics] track firstDeposit from purchase", {
          pixelId: this.pixelId,
          event,
          params,
        });
        this.track("firstDeposit", params);
      }
    }
  }

  track(event, params = {}) {
    if (window.kwaiq.track) {
      window.kwaiq.track(event, params, { pixelId: this.pixelId });
      return;
    }
    if (window.kwaiq.instance) {
      window.kwaiq.instance(this.pixelId).track(event, params);
    }
  }
}

KwaiPixelAnalytics.GetInstance = (pixelId) => {
  const normalizedPixelId = String(pixelId || "").trim();
  if (KwaiPixelAnalytics.instance && KwaiPixelAnalytics.instance.pixelId === normalizedPixelId) {
    return KwaiPixelAnalytics.instance;
  }
  return new KwaiPixelAnalytics(normalizedPixelId);
};
